import { get } from '@/helpers/httpHandler';
import { echo, defaultChannel } from '@/helpers/pusher';

export default {
  getQuantityOpenedOrders({ commit }) {
    return get(`/quantity-opened-orders`).then(response => {
      commit('setOrdersOpened', response.data.orders_opened);
      return response;
    });
  },

  getActualQuantityOpenedOrders({ commit }) {
    echo
      .channel(defaultChannel)
      .listen('.App\\Events\\Order\\OrderOpened', function(data) {
        commit('setOrdersOpened', data.orders_opened);
      });
  }
};
